<template>
    <div class="jobs-post" style="vertical-align: middle;text-align: center">
        <!-- ============= 招聘介绍表 ============= -->
        <div class="jobs-post-introduce" >
            <div class="jobs-introduce-box" style="text-align: left">
                <div style="height: 200px;">
                    <div class="box-title">
                        <div class="box-detaile">锂电池管理与保护应用工程师</div>
                    </div>

                    <div><el-divider></el-divider></div>

                    <!-- 信息表格 -->
                    <el-table
                        :data="tableData1"
                        border
                        style="width: 1200px;text-align: center;">
                        <el-table-column prop="department" label="所属部门" width="320" ></el-table-column>
                        <el-table-column prop="education" label="学历" width="180" align="center"></el-table-column>
                        <el-table-column prop="workyear" label="工作年限" align="center"></el-table-column>
                        <el-table-column prop="place" label="工作地点" align="center"></el-table-column>
                        <el-table-column prop="peoples" label="招聘人数" align="center"></el-table-column>
                        <el-table-column prop="createtime" label="发布时间" align="center"></el-table-column>
                    </el-table>
                </div>

                <div class="jobs-description">
                    <h2>岗位描述: </h2>
                    <span class="description-span">C芯片的测试工作 新产品测试模式验证产品转测试，外包厂测试量产及生产异常处理，竞争对手产品分析C芯片的测试工作 新产品 测试模式验证产品转测试外包厂测试量产及生产异常处理竞争对手产品分析</span>
                </div>

                <div class="description-claim">
                    <h2>岗位要求: </h2>
                    <span class="claim-span">电子、电信相关专业，本科学历，三年工作经验电子、电信相关专业，本科学历，三年工作经验熟悉集成数字电路与仿真电路设计 具备微电子学基本理论概念负责ic芯片的测试工作熟悉集成数字电路与仿真电路设计具备微电子学基本理论概念 负责ic芯片的测试工作</span>
                </div>

                <div class="apply-job">
                    <el-button type="primary" @click="reload">申请岗位</el-button>
                </div>
            </div>
        </div>

        <!-- ============= 推荐岗位 ============= -->
        <div class="job-recommend" >
            <div class="job-recommend-title" style="width: 1200px;display: inline-block">
                <h3 style="margin-left: 5px">推荐岗位:</h3>
                <el-table
                  :data="jobList"
                  stripe
                  :header-cell-style="{background:'rgba(239,245,255,1)',color:'#606266'}"
                  style="width: 900px;display: inline-block">
                  <el-table-column prop="jobName" label="岗位名称" width="240"></el-table-column>
                  <el-table-column prop="jobPlace" label="工作地点" width="240"></el-table-column>
                  <el-table-column prop="peopleNum" label="招聘人数" ></el-table-column>
                  <el-table-column prop="updateTime" label="更新时间" align="center" width="240"></el-table-column>
              </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/http/request'
    export default {
        data () {
            return {
                jobList: [],
                tableData1: [{
                    department: '锂电池管理与保护应用工程师',
                    education: '本科',
                    workyear: '3',
                    place: '上海',
                    peoples: '1人',
                    createtime: '2018-12-14'
                }],
                tableData2: [{
                    jobName: '锂电池管理与保护应用工程师',
                    jobPlace: '上海、深圳、西安',
                    peopleNum: '2',
                    updateTime: '2018-12-14'
                },
                {
                    jobName: '锂电池容量计算法工程师',
                    jobPlace: '上海',
                    peopleNum: '1',
                    updateTime: '2018-12-14'
                },
                {
                  jobName: '锂电池管理与保护应用工程师',
                  jobPlace: '上海、深圳、西安',
                  peopleNum: '2',
                  updateTime: '2018-12-13'
                }]
            }
        },
        mounted:function(){
            this.getJobList();
        },
        methods: {
            reload:function () {
              window.location.reload();
            },
            getJobList: function () {
                api.http_mock('/api/getJobList').then(res => {
                    console.log("tableDataTest---->", res);
                    this.jobList = res;
                })
            },
        }
    }
</script>

<style>
  .jobs-post .el-divider--horizontal {height: 1px;margin: 0;background: rgba(74,144,226,1);width: 1200px;}
  .jobs-post .jobs-post-introduce { height: 800px;background-color: rgba(246,246,246,1);padding-top: 60px;width: 100% !important; }
  .jobs-post .jobs-introduce-box { background-color: #fff;width: 1200px;margin: 0 auto;height: 640px  }
  .jobs-post .box-title { background-color: rgba(239,245,255,1);width: 1200px;height: 40px; }
  .jobs-post .box-detaile { padding-top: 10px;font-size: 20px }
  .jobs-post .jobs-description { width: 1200px;margin: 0 auto;margin-left: 20px }
  .jobs-post .description-span { width:1000px;color: rgba(102,102,102,1) }
  .jobs-post .description-claim { width: 1200px;margin: 0 auto;margin-top: 80px;margin-left: 20px }
  .jobs-post .claim-span {  width:1000px;color: rgba(102,102,102,1) }
  .jobs-post .apply-job { margin: 40px;height: 40px }
  .jobs-post .job-recommend { height: 360px;background-color: #edeff3;width: 100% }
  .jobs-post .job-recommend-title { height: 200px;width: 1200px;padding-top: 40px }
  .jobs-post .el-table th>.cell, .product li { color: rgba(51,51,51,1); }
</style>



// WEBPACK FOOTER //
// src/pages/jobs/post.vue